module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-virtual-consult"
  }, [_c('div', {
    staticClass: "form-virtual-consult__container"
  }, [_c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [(_vm.formSubmitted) ? _c('div', {
    staticClass: "form-virtual-consult__sending-overlay"
  }, [_c('div', {
    staticClass: "form-virtual-consult__sending"
  }, [_vm._v("Sending"), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])]) : _vm._e()]), (_vm.formSuccess) ? _c('div', {
    staticClass: "form-virtual-consult__thank-you"
  }, [_c('h1', [_vm._v("Thank You!")]), _c('p', [_vm._v("Thanks for your submission. We'll get back to you shortly!")]), _c('router-link', {
    staticClass: "form-virtual-consult__home-button",
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1) : _vm._e(), (!_vm.formSuccess) ? _c('form', {
    staticClass: "form-virtual-consult__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-virtual-consult__group form-virtual-consult__group--inline"
  }, [_c('div', {
    staticClass: "form-virtual-consult__item"
  }, [_c('span', {
    staticClass: "form-virtual-consult__label",
    class: {
      'form-virtual-consult__label--active': _vm.firstName !== '' || _vm.active === 'firstName'
    },
    on: {
      "click": function($event) {
        _vm.focused("firstName")
      }
    }
  }, [_vm._v("Patient's First Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    staticClass: "form-virtual-consult__input",
    class: {
      'form-virtual-consult__input--error': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.focused("firstName")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-virtual-consult__item"
  }, [_c('span', {
    staticClass: "form-virtual-consult__label",
    class: {
      'form-virtual-consult__label--active': _vm.lastName !== '' || _vm.active === 'lastName'
    },
    on: {
      "click": function($event) {
        _vm.focused("lastName")
      }
    }
  }, [_vm._v("Patient's Last Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    staticClass: "form-virtual-consult__input",
    class: {
      'form-virtual-consult__input--error': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.focused("lastName")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-virtual-consult__group form-virtual-consult__group--inline"
  }, [_c('div', {
    staticClass: "form-virtual-consult__item"
  }, [_c('span', {
    staticClass: "form-virtual-consult__label",
    class: {
      'form-virtual-consult__label--active': _vm.clientEmail !== '' || _vm.active === 'clientEmail'
    },
    on: {
      "click": function($event) {
        _vm.focused("clientEmail")
      }
    }
  }, [_vm._v("Patient's Email Address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientEmail),
      expression: "clientEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-virtual-consult__input",
    class: {
      'form-virtual-consult__input--error': _vm.errors.has('clientEmail')
    },
    attrs: {
      "name": "clientEmail",
      "type": "text"
    },
    domProps: {
      "value": (_vm.clientEmail)
    },
    on: {
      "focus": function($event) {
        _vm.focused("clientEmail")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientEmail = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-virtual-consult__item"
  }, [_c('span', {
    staticClass: "form-virtual-consult__label",
    class: {
      'form-virtual-consult__label--active': _vm.clientPhone !== '' || _vm.active === 'clientPhone'
    },
    on: {
      "click": function($event) {
        _vm.focused("clientPhone")
      }
    }
  }, [_vm._v("Patient's Phone Number")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientPhone),
      expression: "clientPhone"
    }],
    staticClass: "form-virtual-consult__input",
    class: {
      'form-virtual-consult__input--error': _vm.errors.has('clientPhone')
    },
    attrs: {
      "name": "clientPhone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.clientPhone)
    },
    on: {
      "focus": function($event) {
        _vm.focused("clientPhone")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientPhone = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-virtual-consult__group form-virtual-consult__group--textarea"
  }, [_c('span', {
    staticClass: "form-virtual-consult__label",
    class: {
      'form-virtual-consult__label--active': _vm.message !== '' || _vm.active === 'message'
    },
    on: {
      "click": function($event) {
        _vm.focused("message")
      }
    }
  }, [_vm._v("Message")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-virtual-consult__input form-virtual-consult__input--textarea",
    class: {
      'form-virtual-consult__input--error': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "text"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "focus": function($event) {
        _vm.focused("message")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-virtual-consult__group"
  }, [_vm._v("File Attachment (You Can Upload Multiple Images)    ")]), _c('div', {
    staticClass: "form-virtual-consult__group form-virtual-consult__group--inline"
  }, [_c('div', {
    staticClass: "form-virtual-consult__item"
  }, [_c('label', {
    staticClass: "form-virtual-consult__input--upload"
  }, [_c('input', {
    ref: "uploads",
    attrs: {
      "name": "images",
      "type": "file",
      "accept": "image/jpg, image/jpeg, image/png",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.upload
    }
  }), _c('span', [_vm._v("Choose Files")])])]), _c('div', {
    staticClass: "form-virtual-consult__item"
  }, [_c('span', [_vm._v(_vm._s(_vm.images) + " images uploaded.")])])]), _c('div', {
    staticClass: "form-virtual-consult__group form-virtual-consult__group--inline"
  }, [_c('div', {
    staticClass: "form-virtual-consult__checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agree),
      expression: "agree"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-virtual-consult__input--checkbox",
    attrs: {
      "name": "agree",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agree) ? _vm._i(_vm.agree, null) > -1 : (_vm.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agree = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "form-virtual-consult__checkbox-overlay",
    class: {
      'form-virtual-consult__checkbox-overlay--error': _vm.errors.has('agree')
    }
  }), _c('label', {
    staticClass: "form-virtual-consult__label"
  }, [_vm._v(" By checking this box I agree to send my photos and information via email and I understand that the virtual exam is not always an exact diagnosis. In some cases additional records or appointments may be required. ")])])]), _c('div', {
    staticClass: "form-virtual-consult__button-group"
  }, [_c('button', {
    staticClass: "form-virtual-consult__submit-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.formSubmitted
    },
    on: {
      "click": _vm.validate
    }
  }, [_c('span', [_vm._v("Send        ")])])])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b2a544","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/forms/virtual-form/virtual-form.pug
// module id = 1130
// module chunks = 1